import { combineReducers } from "redux";

import formData from "./formDataReducer";
import choices from "./choiceReducer";
import hidden from "./hiddenReducer";
import disabled from "./disabledReducer";
import packaged from "./packagedReducer";

const rootReducer = combineReducers({
  formData,
  choices,
  hidden,
  disabled,
  packaged,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
